export class SignatureCanvas {
  canvas: HTMLCanvasElement;
  status: "touchstart" | "touchend" | "touchmove" | string;
  context: {
    width: number;
    height: number;
    dpr: number;
    waterFlag: {
      name: string;
    };
  } & Record<string, any>;
  ctx: CanvasRenderingContext2D;
  drawTasks: any[] = [];
  listeners: Record<string, any> = {};
  touchPoint: any[] = [];
  _rect: any;

  constructor(canvas: HTMLCanvasElement, config: any) {
    this.canvas = canvas;
    this.ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    this.context = {
      _config: config,
      width: window.document.body.clientWidth - 70,
      height: window.document.body.clientHeight,
      dpr: window.devicePixelRatio || 3,
      waterFlag: {
        name: config?.waterFlag?.name || "默认水印",
      }, // 水印
    };
    this.status = "idle";
    this.init();
    this.draw();
  }

  init() {
    this.canvas.width = this.context.width * this.context.dpr;
    this.canvas.height = this.context.height * this.context.dpr;
    this.ctx.scale(this.context.dpr, this.context.dpr);
    this.register("waterFlag", () => this.drawWaterFlag());

    this.listen("touchstart", (e) => {
      this.status = "touchstart";
      this.touchPoint = this.getTouchPoint(e.touches[0]);
    });

    this.listen("touchend", (e) => {
      this.status = "touchend";
      this.ctx.beginPath();
    });

    this.listen("touchmove", (e) => {
      e.preventDefault();
      this.status = "touchmove";
      this.ctx.moveTo(this.touchPoint[0], this.touchPoint[1]);
      this.touchPoint = this.getTouchPoint(e.touches[0]);
      this.ctx.lineWidth = 8;
      this.ctx.strokeStyle = "#676767";
      this.ctx.lineCap = "round";
      this.ctx.lineJoin = "round";
      this.ctx.lineTo(this.touchPoint[0], this.touchPoint[1]);
      this.ctx.stroke();
    });
  }

  getTouchPoint(touch: any) {
    if(!this._rect) {
      this._rect = this.canvas.getBoundingClientRect();
    }
    return [touch.clientX - this._rect.left, touch.clientY - this._rect.top];
  }

  register(name: string, drawFunc: () => void) {
    this.drawTasks.push({
      name,
      drawFunc,
    });
  }

  listen(name: string, func: (e: TouchEvent) => void) {
    if (this.listeners[name]) {
      this.canvas.removeEventListener(name, this.listeners[name]);
      this.listeners[name] = null;
    }
    this.listeners[name] = func;
    this.canvas.addEventListener(name, this.listeners[name]);
  }

  draw() {
    this.drawTasks.forEach((task) => {
      task.drawFunc.call(this);
    });
  }

  drawWaterFlag() {
    const defaultOptions = {
      lineText: Array.from({ length: 12 })
        .fill(this.context.waterFlag.name)
        .join("       "),
      width: this.canvas.width || 0,
      height: this.canvas.height || 0,
      backgroundColor: "#FFF",
      font: "14px 方正黑体",
      fontColor: "#DDD",
      rotate: Math.PI *  (75 / 180),
    };

    this.ctx.fillStyle = defaultOptions.backgroundColor;
    this.ctx.fillRect(0, 0, defaultOptions.width, defaultOptions.height);
    this.ctx.rotate(defaultOptions.rotate);
    this.ctx.font = defaultOptions.font;
    this.ctx.fillStyle = defaultOptions.fontColor;
    for (let i = 0; i < 18; i++) {
      this.ctx.fillText(defaultOptions.lineText, -100 +(i % 2) * 50, 100 * (i - 2));
    }
    this.ctx.rotate(-defaultOptions.rotate);
    this.ctx.rotate(Math.PI / 2);
    this.ctx.font = "15px 微软雅黑";
    this.ctx.fillStyle = "#9B9B9B";

    this.ctx.fillText(
      "请按照此方向，在下方空白处手写签名",
      this.canvas.height / this.context.dpr / 2 - 130,
      -this.canvas.width / this.context.dpr + 35
    );
    this.ctx.rotate(-Math.PI / 2);
  }

  clear() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.draw();
  }

  destroy() {
    for (let [key, func] of Object.entries(this.listeners)) {
      this.canvas.removeEventListener(key, func);
    }
  }

  generateImage() {
    return this.canvas.toDataURL("image/png");
  }
}
